
















































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';

import { ResultadoDeExameFormItem } from '../../../../back/src/types';

export default Vue.extend({
  name: 'ResultadosDeExamesGrupoItemForm',
  props: {
    resultadoDeExameFormItem: {
      type: Object as () => ResultadoDeExameFormItem,
    },
  },
  data() {
    return {
      valid: true,
      form: {
        exameId: _.get(this.resultadoDeExameFormItem, 'exameId', null),
        ordem: _.get(this.resultadoDeExameFormItem, 'ordem', null),
        nomeExame: _.get(this.resultadoDeExameFormItem, 'nomeExame', null),
        resultado: _.get(this.resultadoDeExameFormItem, 'resultado', null),
        status: _.get(this.resultadoDeExameFormItem, 'status', null),
        observacoes: _.get(this.resultadoDeExameFormItem, 'observacoes', null),
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
    };
  },
  computed: {
    classRow(): string {
      if (!this.form.nomeExame
        && !this.form.resultado
        && !this.form.status
        && !this.form.observacoes
      ) {
        if (!this.valid) {
          return 'error lighten-4';
        }
        return '';
      }
      if (!this.valid) {
        return 'error lighten-4';
      }
      return 'info lighten-5';
    },
    formItem(): Vue & { validate: () => boolean, resetValidation: () => boolean } {
      return this.$refs.formItem as Vue & {
        validate: () => boolean,
        resetValidation: () => boolean
      };
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('atualiza-item', val);
      },
      deep: true,
    },
  },
  mounted() {
    this.$root.$on('validate-resultados-de-exames-grupo-item-form', () => {
      this.formItem.validate();
    });
  },
  methods: {
    limpaForm() {
      this.form.resultado = null;
      this.form.status = null;
      this.form.observacoes = null;
      this.$emit('atualiza-item', this.form);
      this.formItem.resetValidation();
    },
    removeItem() {
      this.$emit('remove-item', this.form.ordem);
    },
  },
});
